// Recovered compiled webpack factory 23919. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { $: () => r, q: () => o });
  var n = i(24531);
  let s =
      /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu,
    r = (t, e) => (i) =>
      !!(
        ("string" == typeof i && s.test(i) && i.startsWith(t)) ||
        (e && null != i && Object.prototype.hasOwnProperty.call(i, e))
      ),
    o = (t, e, i) => (s) => {
      if ("string" != typeof s) return s;
      let [r, o, a, l] = s.match(n.S);
      return {
        [t]: parseFloat(r),
        [e]: parseFloat(o),
        [i]: parseFloat(a),
        alpha: void 0 !== l ? parseFloat(l) : 1,
      };
    };
}
